// setupGlobalErrorFilters.js
//
// Wallet extensions (MetaMask, Phantom, Coinbase Wallet, etc.) inject a
// provider into every page and sometimes throw "Failed to connect to
// MetaMask" / unhandled rejections that have nothing to do with our code.
// In development these surface as full-screen overlays via CRA's error
// reporter and confuse users.
//
// We silence them aggressively but ONLY when the error clearly originates
// from a `chrome-extension://` URL. Anything from the app itself still
// surfaces normally so we don't hide real bugs.

function looksLikeExtensionError(input) {
  if (!input) return false;
  const text =
    typeof input === 'string'
      ? input
      : (input.stack || input.message || input.toString?.() || '');
  if (typeof text !== 'string') return false;
  return (
    text.includes('chrome-extension://') ||
    text.includes('moz-extension://') ||
    text.includes('Failed to connect to MetaMask') ||
    text.includes('MetaMask extension not found')
  );
}

if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (e) => {
      if (
        looksLikeExtensionError(e?.filename) ||
        looksLikeExtensionError(e?.error) ||
        looksLikeExtensionError(e?.message)
      ) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
      }
    },
    true,
  );

  window.addEventListener(
    'unhandledrejection',
    (e) => {
      if (looksLikeExtensionError(e?.reason)) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
      }
    },
    true,
  );

  // Some wallet extensions surface the same payload via console.error which
  // react-error-overlay does NOT actually read, but we mute it anyway so the
  // browser console stays focused on real app errors.
  const originalConsoleError = console.error;
  console.error = function patched(...args) {
    try {
      if (args.some((a) => looksLikeExtensionError(a))) return;
    } catch (_) {
      /* fall through */
    }
    return originalConsoleError.apply(this, args);
  };
}

export {};
